<template>
  <ppt-modal class="save-scenario-modal">
    <header slot="header">
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
    </header>
    <section slot="body">
      <div class="form-group">
        <label>
          Name:
        </label>
        <input v-model="scenarioName" class="form-control input-lg" placeholder="Eg. Aces versus kings">
      </div>
      <button
        class="btn btn-lg btn-primary"
        v-on:click="save()"
      >
        Save
      </button>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';

export default {
  name: 'save-scenario-modal',
  components: {
    'ppt-modal': PPTModal,
  },
  data: function () {
    return {
      scenarioName: '',
    };
  },
  methods: {
    save: function () {
      this.$emit('save', this.scenarioName);
      $(this.$el).modal('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
  .save-scenario-modal {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/save-scenario-modal.vue